import React, {useState, useEffect} from 'react'
import firebase from '../../firebase/config'
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import {useHistory, useLocation} from 'react-router-dom';
import moment from 'moment';
import { DateRangePicker, START_DATE, END_DATE } from 'react-nice-dates'
import { es } from 'date-fns/locale'
import 'react-nice-dates/build/style.css'

function Orders() {

    const data = useLocation()
    const history = useHistory()
    const [nameValue, setNameValue] = useState(null)
    const [nroValue, setNroValue] = useState(null)
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(5)
    const [totalItemCount, setTotalItemCount] = useState(0)
    let statusValues = ["Status de orden", "Por confirmar", "Confirmada", "Cancelada", "Atendido", "Despachado", "Entregado", "Por cobrar", "Todas"]
    let tiposValues = ["Tipo de orden", "Producto", "Servicio", "Videoconsulta", "Todas"]
    let statusPagosValues = ["Status de pago", "Por cobrar", "Liquidada", "Por liquidar", "Todas"]
    const [statusValue, setStatusValue] = useState(null);
    const [statusPagoValue, setStatusPagoValue] = useState(null);
    const [tipo, setTipo] = useState(null);
    const [descripcion, setDescripcion] = useState(null);  
    const [orders, setOrders] = useState([])
    const [user, setUser] = useState({})
    const [order, setOrder] = useState({})
    const [orderSell, setOrderSell] = useState({})
    const [countryInfo, setCountryInfo] = useState({})
    const [filteringOrders, setFilteringOrders] = useState(false)

    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()

    function filterName(list, val) {
      let tipos = []
      for(let i = 0; i < list.length; i++){
        let u = list[i].user.toLowerCase()
        if(u.includes(val.toLowerCase())){
          tipos.push(list[i])
        }
      }
      return tipos
    }
   
    function filterNro(list, val) {
      let tipos = []
      for(let i = 0; i < list.length; i++){
        let u = list[i].oid.toLowerCase()
        if(u.includes(val.toLowerCase())){
          tipos.push(list[i])
        }
      }
      return tipos
    }
    
    function filterStatus(list, val) {
      let tipos = []
      for(let i = 0; i < list.length; i++){
        let u = list[i].status
        if(u === val){
          tipos.push(list[i])
        }
      }
      return tipos
    }
    
    function filterType(list, val) {
      let tipos = []
      for(let i = 0; i < list.length; i++){
        let u = list[i].tipoOrden
        if(u === val){
          tipos.push(list[i])
        }
      }
      return tipos
    }

    const getOrders = async(aliadoId, state, aliado) =>{
      let tipos = [];
      
      let id = aliado.role === "Administrador" ? aliadoId : aliado.aliadoAdminId

      try{
        const reference = state ? firebase.db.collection('Ordenes').where("aliadoId", "==", id).where("status", "==", "Por confirmar") 
        : firebase.db.collection('Ordenes').where("aliadoId", "==", id)
        
        reference.get().then(val => {
          val.docs.forEach(item=>{
            let orden = item.data()
            if(orden.tipoOrden === "Servicio" || orden.tipoOrden === "Videoconsulta" ){
              firebase.db.collection('Ordenes').doc(orden.oid).collection("Items").get().then((items)=>{
                let item2 = items.docs[0].data()
                console.log(item2)
                orden["descripcion"] = item2.titulo
              })
            }else{
              orden["descripcion"] = "Varios"
            }
            tipos.push(orden)
          })
          
          let allList = tipos
          let filteredName = nameValue ? filterName(tipos, nameValue) : allList
          let filteredNro = nroValue ? filterNro(filteredName, nroValue) : filteredName
          let filteredStatus = statusValue !== "Todas" && statusValue ? filterStatus(filteredNro, statusValue) : filteredNro
          let filteredType = tipo !== "Todas" && tipo ? filterType(filteredStatus, tipo) : filteredStatus
          setOrders(filteredType.sort((a, b) => b.createdOn - a.createdOn))
          
          setTimeout(() => {
            setTotalItemCount(tipos.length)
          }, 1000);
          
        })

        
      }catch(e){
        console.log("Error: " + e)
      }
    
    }

    async function getOrdersEmploye(aliadoId, aliado){
      let itemsList = []
      // let serviciosRol = []
      let serviciosRol = []
      let itemsListFiltered = []
      let ordersFiltered = []
      let id = aliadoId.role === "Administrador" ? aliadoId : aliado.aliadoAdminId
      try{
        //Obtener todos los ids de las ordenes y los titulos de los servicios de las ordenes del admin
        await firebase.db.collection("Ordenes").where("aliadoId", "==", id).where("tipoOrden", "==", "Servicio").get().then((val)=>{
          val.docs.forEach((doc)=>{
            firebase.db.collection("Ordenes").doc(doc.data().oid).collection("Items").get().then((items)=>{
              items.docs.forEach((item)=>{
                let object = {
                  oid: item.data().oid,
                  titulo: item.data().titulo,
                }
                itemsList.push(object)
              })
            })
          })
        })
        
        setFilteringOrders(true)

        //Obtener todos los servicios de todas las categorias en base al rol del aliado
        await firebase.db.collection("Roles").doc(aliado.role).collection("CategoriasServicios").get().then((val)=>{
          val.docs.forEach((doc)=>{
            firebase.db.collection("Roles").doc(aliado.role).collection("CategoriasServicios").doc(doc.id).collection("Servicios").get().then((servs)=>{
              servs.docs.forEach((ser)=>{
                serviciosRol.push(ser.id)
              })
            })
          })
        })

        new Promise(resolve => setTimeout(resolve, 2));
        
        //El siguiente paso es hacer un ciclo para comparar si el titulo de un item es igual al titulo de la lista servicio
        for(let i = 0; i < serviciosRol.length; i++){
          let servicio = serviciosRol[i]
          for(let i = 0; i < itemsList.length; i++){
            let item = itemsList[i]
            if(servicio === item.titulo){
              itemsListFiltered.push(item)
            }
          } 
        }
        
        new Promise(resolve => setTimeout(resolve, 2));
        
        for(let i = 0; i < itemsListFiltered.length; i++){
          let oid = itemsListFiltered[i].oid
          await firebase.db.collection("Ordenes").doc(oid).get().then((val)=>{
            ordersFiltered.push(val.data())
          })
        }
        
        new Promise(resolve => setTimeout(resolve, 2));
        
        // console.log(ordersFiltered)
        // console.log(itemsList)
        setFilteringOrders(false)
        setOrders(ordersFiltered.sort((a, b) => b.createdOn - a.createdOn))

      }catch(e){
        console.log("Error: " + e)
      }
    }

    const ExportToExcel = ({ apiData, fileName }) => {
      const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      
      let today = moment().format('L')

      const exportToCSV = async(d, fileName) => {
        await Promise.all(d.map(async (o) => {
          for(let v in o){
            v.toString() === "statusCita" && delete o[v]
            v.toString() === "tieneDelivery" && delete o[v]
            v.toString() === "hora" && delete o[v]
            v.toString() === "mid" && delete o[v]
            // v.toString() === "precio" && delete o[v]
            v.toString() === "fecha" && delete o[v]
            v.toString() === "user" && delete o[v]
            v.toString() === "uid" && delete o[v]
            v.toString() === "aliadoId" && delete o[v]
            v.toString() === "calificacion" && delete o[v]
            v.toString() === "nombreComercial" && delete o[v]
            v.toString() === "localidadId" && delete o[v]
            v.toString() === "culqiOrderId" && delete o[v]
            v.toString() === "atendidoStatus" && delete o[v]
            v.toString() === "delivery" && delete o[v]
            v.toString() === "preference_id" && delete o[v]
            v.toString() === "date" && delete o[v]
          }
          
        }))
        const ws = XLSX.utils.json_to_sheet(d);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, `ordenes-${today}` + fileExtension);
      };
    
      return (
        <button className="btn btn-outline-secondary" onClick={(e) => exportToCSV(apiData, fileName)}>Exportar a Excel <i className="material-icons">save_alt</i></button>
      );
    }

    useEffect(() => {
        firebase.getCurrentUser().then((val)=>{
          setUser(val)
          if(val.role === "Administrador"){
            data.state === "Por confirmar" ? getOrders(val.aliadoId, true, val) : getOrders(val.aliadoId, false, val)
          }else{
            getOrdersEmploye(val.aliadoId, val)
          }
          firebase.getCountryInfo(val.pais).then((val)=>{
            setCountryInfo(val.data())
          })
        });
    }, [])

    return (
      <div className="main-content-container container-fluid px-4">
              <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
                <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
                  <div className="row align-items-center">
                    <div className="col">
                      <p className="page-title">Órdenes</p>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-1 mb-0">
                  <div className="row align-items-center justify-content-space-around">
                    {/* <i className="material-icons color-white display-5">help_outline</i> */}
                  </div>
                </div>
              </div>
              <div className="form-row align-items-center justify-content-spacebetween mb-4">
                <div className="row no-gutters align-items-center justify-content-space-betweeen">
                <div className="form-group mr-3">
                  <input type="text" placeholder="Nombre del cliente" className="form-control" onChange={(e)=>{setNameValue(e.target.value)}}/>
                </div>
                <div className="form-group mr-3">
                  <input type="text" placeholder="Nro. de la órden" className="form-control" onChange={(e)=>{setNroValue(e.target.value)}}/>
                </div>
                <div className="form-group mr-3">
                  <select className="form-control" onChange={(e) => {setStatusValue(e.target.value)}}>
                    {statusValues.map(data => (
                      <option key={data} value={data}>{data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group mr-3">
                  <select className="form-control" onChange={(e) => {setStatusPagoValue(e.target.value)}}>
                    {statusPagosValues.map(data => (
                        <option key={data} value={data}>{data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group mr-3">
                  <select className="form-control" onChange={(e) => {setTipo(e.target.value)}}>
                    {tiposValues.map(data => (
                      <option key={data} value={data}>{data}</option>
                      ))}
                  </select>
                </div>
                <div className="form-group mr-3">
                  <input type="text" placeholder="Descripción de la órden" className="form-control" onChange={(e)=>{setDescripcion(e.target.value)}}/>
                </div>
                <div className="form-group mr-3">
                  <button className="btn btn-primary" onClick={()=>{getOrders(user.aliadoId, false, user)}}>Buscar  <i className="material-icons">search</i></button>
                </div>
                {/* <DateRangePicker
                  startDate={startDate}
                  endDate={endDate}
                  onStartDateChange={setStartDate}
                  onEndDateChange={setEndDate}
                  minimumDate={new Date()}
                  minimumLength={1}
                  format='dd MMM yyyy'
                  locale={es}
                >
                  {({ startDateInputProps, endDateInputProps, focus }) => (
                    <div className='date-range'>
                      <input
                        className={'input' + (focus === START_DATE ? ' -focused' : '')}
                        {...startDateInputProps}
                        placeholder='Start date'
                      />
                      <span className='date-range_arrow' />
                      <input
                        className={'input' + (focus === END_DATE ? ' -focused' : '')}
                        {...endDateInputProps}
                        placeholder='End date'
                      />
                    </div>
                  )}
                </DateRangePicker> */}
                <div className="form-group mr-3">
                  {orders.length > 0 && <ExportToExcel apiData={orders} fileName={"Ordenes"} />}
                </div>
                </div>
              </div>
              <div className="row">
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="mb-2 row orders-title">
                      <div className="col-md-1">
                        <p className="mb-2">Cliente</p>
                      </div>
                      <div className="col-md-2">
                        <p className="mb-2">Nro. Orden</p>
                      </div>
                      <div className="col-md-1">
                        <p className="mb-2">Tipo</p>
                      </div>
                      <div className="col-md-2">
                        <p className="mb-2">Descripción</p>
                      </div>
                      <div className="col-md-1">
                        <p className="mb-2">Fecha</p>
                      </div>
                      <div className="col-md-2">
                        <p className="mb-2">Status</p>
                      </div>
                      <div className="col-md-1">
                        <p className="mb-2">Monto</p>
                      </div>
                      <div className="col-md-2">
                        <p className="mb-2">Status pago</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="orders-container">
                      {
                        orders.length > 0 && !filteringOrders ? orders.map(order=>{
                          let oc = moment(order.createdOn.toDate()).format("L")
                          return(
                            <div onClick={() => {
                              history.push({
                                pathname: "/orders/order",
                                state: {oid: order.oid}
                              })
                            }} key={order.oid} className="mb-2 row order-child">
                              {/* Nombre */}
                              <div className="col-md-1 color-primary">
                                <p className="mb-0">{order.user}</p>
                              </div>
                              {/* Nro */}
                              <div className="col-md-2 ">
                                <p className="mb-0">{order.oid}</p>
                              </div>
                              {/* Tipo */}
                              <div className="col-md-1 ">
                                <p className="mb-0 text-orders-ellipsis">{order.tipoOrden}</p>
                              </div>
                              {/* Descripcion */}
                              <div className="col-md-2 ">
                                <p className="mb-0">{order.descripcion} <span style={{ visibility: "hidden", fontSize: "0px" }}>{totalItemCount}</span></p>
                              </div>
                              {/* Fecha */}
                              <div className="col-md-1">
                                <p className="mb-0">{oc}</p>
                              </div>
                              {/* Status */}
                              <div className={order.status === "Confirmada" ? "col-md-2 color-success" : order.status === "Por Confirmar" ||  order.status === "Por confirmar" ? "col-md-2 color-secondary" :"col-md-2 color-danger"}>
                                <p className="mb-0">{order.status}</p>
                              </div>
                              {/* Monto */}
                              <div className="col-md-1 color-success">
                                <p className="mb-0">{countryInfo.simbolo ?? " "}{order.precio}</p>
                              </div>
                              {/* Status pago */}
                              <div className="col-md-2">
                                <p className="mb-0">{order.statusPago}</p>
                              </div>
                            </div>
                          )
                        }) : <div className="text-center"><p>{filteringOrders ? "Filtrando tus órdenes..." : "No hay órdenes"}</p></div>
                      }
                    </div>
                  </div>
              </div>
          </div>
    )

}

export default Orders